import * as React from 'react';
import {useEffect, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import {NavLink} from "react-router-dom";
import {Button, CircularProgress, Stack} from "@mui/material";
import {Logout, Person} from "@mui/icons-material";
import {getAuthToken} from "../functions/getAuthToken";
import {API_URL} from "../config";
import axios from "axios";
import {auth} from "../firebase/clientApp";
import {useUserStore} from "../store/userStore";
import {useAthletesStore} from "../store/athletesStore";

const drawerWidth = 240;

const pages = [
    {
        title: 'Atleti e Iscrizioni',
        link: "/",
        icon: <SportsSoccerIcon/>
    },
    {
        title: 'Profilo',
        link: "/profilo",
        icon: <Person/>
    }
]

function HomeLayout(props) {
    const {window, page, children} = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [loggingOut, setLoggingOut] = React.useState(false);
    const [loading, setLoading] = useState(false)
    const {setUser, user} = useUserStore()
    const {setAthletes, athletes} = useAthletesStore()

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleLogout = async () => {
        setLoggingOut(true)
        const token = await getAuthToken()
        await axios.post(`${API_URL}logout`, {}, {headers: {'Authorization': `${token}`}})
            .then(() => {
                auth.signOut()
            })
        setLoggingOut(false)
    }

    const getData = async () => {
        setLoading(true)
        const token = await getAuthToken()
        await axios.get(`${API_URL}me`,{headers: {"Authorization": `${token}`}})
            .then(res => {
                setAthletes(res.data.athletes)
                let u = res.data
                delete u.athletes
                setUser(u)
            })
            .catch(err => {})
        setLoading(false)
    }

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            getData()
        })
    },[])

    const drawer = (
        <div style={{height:'100%'}}>
            <Toolbar>

            </Toolbar>
            <Divider/>
            <Stack justifyContent={'space-between'} sx={{height:'90%'}}>
                <List>
                    <Box sx={{px:1}}>
                        {pages.map((page, index) => (
                            <ListItem key={page.title} disablePadding component={NavLink} to={page.link}
                                      sx={{color: 'black'}}>
                                <ListItemButton sx={{borderRadius:'50rem'}}>
                                    <ListItemIcon sx={{color: 'inherit'}}>
                                        {page.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={page.title} sx={{color: 'inherit'}}/>
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </Box>
                </List>
                <Button startIcon={<Logout/>} onClick={handleLogout}>
                    Logout
                </Button>
            </Stack>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <AppBar
                position="fixed"
                sx={{
                    width: {sm: `calc(100% - ${drawerWidth}px)`},
                    ml: {sm: `${drawerWidth}px`},
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{mr: 2, display: {sm: 'none'}}}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        {page}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: {xs: 'block', sm: 'none'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: {xs: 'none', sm: 'block'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{flexGrow: 1, p: 3, width: {sm: `calc(100% - ${drawerWidth}px)`}}}
            >
                <Toolbar/>
                {loading ? <CircularProgress/> : children}
            </Box>
        </Box>
    );
}

export default HomeLayout;
